import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useQuestionSetFindById from '@opsbase/react-gql-hooks/questionset/useQuestionSetFindById';
import useQuestionSetPublish from '@opsbase/react-gql-hooks/questionset/useQuestionSetPublish';
import markdown from '@opsbase/react-markdown';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo } from 'react';
function QuestionSetPublishDialog() {
    const { id } = useParams();
    const dataType = DataType.OPDEFINITION;
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { raise } = useNotificationActions();
    const publishQuestionSet = useQuestionSetPublish();
    const { loading, data } = useQuestionSetFindById({
        variables: { id },
        skip: id === 'selected',
    });
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const title = id === 'selected' ? selecteds.map(o => o.title).join(', ') : data === null || data === void 0 ? void 0 : data.title;
    const handleAction = useCallback(async () => {
        clearSelection();
        return raise(Promise.all(ids.map(theId => publishQuestionSet({ id: theId }))), i18n.t('questionset-update-successful'));
    }, [clearSelection, raise, ids, publishQuestionSet]);
    const text = markdown(i18n.t('confirm-questionset-update', {
        title,
        count: ids.length,
    }));
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, agreeText: i18n.t('update'), notAgreeText: i18n.t('cancel'), color: Palette.warning, loading: loading },
        React.createElement(Text, null, text)));
}
export default QuestionSetPublishDialog;
